import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServicioService, StorageService} from '../../servicios/index.service';
import { FormGroup, FormControl,Validators } from '@angular/forms';
import { AgmMap, MapsAPILoader } from '@agm/core';
import {} from '@types/googlemaps';
import 'rxjs/add/operator/map';

declare var $;
declare var google: any;

@Component({
  selector: 'app-servicio',
  templateUrl: './servicio.component.html',
  styles: [`
      agm-map {
        height: 400px;
      }
    `]
})
export class ServicioComponent implements OnInit {

  @ViewChild('buscar_uno') public searchElement: ElementRef;
  @ViewChild(AgmMap)
  public agmMap: AgmMap;
  id:string;
  dataServ:any = {};
  nom_empresa:any;
  nom_resp:any;
  ref:any;
  dir_inicio:any;
  dir_fin:any;
  realizado:any;
  status:any;
  registro:any;
  tel:any;
  lat:number = 21.9934775;
  lng:number = -99.0176878;
  zoom:number = 12;
  inic_lat:number;
  inic_lng:number;
  fin_lat:number;
  fin_lng:number;
  street:boolean = false;
  formEditService:FormGroup;
  marca_ini:boolean = false;
  marca_fin:boolean = false;
  clase:number = 0;
  btnEditDirFin:number = 0;
  direccion:any = null;
  validForm:number = 0;
  caract:any;
  //Caracteristicas
  user_serv:any;
  confirm_empresa:any;
  resp_confirm:any;
  carac_confirm:any;
  time:any;
  select_t_unidad:any;
  v_especializado_form:any;
  remolque_form:any;
  remolque_ref_form:any;
  accesorios_form:any;
  select_t_carga:any;

  constructor( private route: ActivatedRoute, private _ss:ServicioService,
               public ngZone:NgZone, private mapsAPILoader:MapsAPILoader,
               private _storage:StorageService) {

    document.getElementById('body').className = 'hold-transition skin-blue sidebar-mini sidebar-collapse';
    this.route.params.subscribe( params=>{
          this.id = params['id'];
        } );
    this.form_edit_service();
    

  }

  ngOnInit() {
    this.buscador();
    this.datos();
    $(document).ready(function() {
      $("body").css("overflow","auto");
    });
  }

  datos(){
    this._ss.getServicio( this.id ).subscribe( dataId => {
      this.dataServ = dataId;
      this.nom_empresa = this.dataServ.nom_empresa;
      this.nom_resp = this.dataServ.nom_resp;
      this.ref = this.dataServ.ref;
      this.tel = this.dataServ.tel;
      this.dir_inicio = this.dataServ.inic_dir;
      this.dir_fin = this.dataServ.fin_dir;
      this.realizado = this.dataServ.realizado;
      this.status = this.dataServ.status;
      this.registro = this.dataServ.timestamp;
      this.inic_lat = this.dataServ.inic_lat;
      this.inic_lng = this.dataServ.inic_lng;
      this.fin_lat = this.dataServ.fin_lat;
      this.fin_lng = this.dataServ.fin_lng;
      this.caract = this.dataServ.caract;
      //caracteristicas del viaje
      this.user_serv = this.dataServ.user;
      this.confirm_empresa = this.dataServ.confirm_empresa;
      this.resp_confirm = this.dataServ.resp_confirm;
      this.carac_confirm = this.dataServ.carac_confirm;
      this.time = this.dataServ.time_fin_serv;
    });
  }

  form_edit_service(){
    let time = new Date().getTime();
    this.formEditService = new FormGroup({
      'nom_empresa':new FormControl('', [ Validators.required, Validators.minLength(3)] ),
      'nom_resp':new FormControl('', [ Validators.required, Validators.minLength(5)] ),
      'ref': new FormControl(''),
      'num_tel':new FormControl('', [ Validators.required, Validators.pattern("[0-9]{10}")]),
      'ubic_inic': new FormControl(''),
      'dir_fin': new FormControl(''),
      'status':new FormControl('0'),
      'timestamp': new FormControl(time),
      'carac': new FormControl('', [Validators.required, Validators.minLength(8)]),
      't_unidad_selec': new FormControl(''),
      't_unidad': new FormControl(''),
      'v_especializado': new FormControl(''),
      'remolque': new FormControl(''),
      'remolque_ref': new FormControl(''),
      'accesorios': new FormControl(''),
      't_carga': new FormControl(''),
      't_carga_esp': new FormControl(''),
      'precio': new FormControl('', [Validators.required, Validators.pattern("[0-9]{1,8}")])
    });
  }

  edit_serv(){
    $('#editarService').on('shown.bs.modal', function() {
      //this.agmMap.triggerResize();
    });
  }

  guardar_edit_service(){
    let form = this.formEditService.value;
    console.log(form);

    if( form.t_unidad_selec == "" && form.t_unidad == "" || form.t_unidad_selec == undefined ){
      if(this.dataServ.t_unidad == undefined){
        this.select_t_unidad = null;
      }else{
        this.select_t_unidad = this.dataServ.t_unidad;
      }
    }else if( form.t_unidad_selec !== "" && form.t_unidad == "" ){
      this.select_t_unidad = form.t_unidad_selec;
    }else if(form.t_unidad_selec == "1"){
      this.select_t_unidad = form.t_unidad;
    }else if( form.t_unidad_selec !== "1" && form.t_unidad !== "" ){
      this.select_t_unidad = form.t_unidad_selec;
    }

    if(form.v_especializado == "" && this.dataServ.v_especializado == undefined ){
      this.v_especializado_form = null;
      //console.log(this.v_especializado_form);
    }else if( form.v_especializado !== "" ){
      this.v_especializado_form = form.v_especializado;
      //console.log(this.v_especializado_form);
    }

    if(form.remolque == "" && this.dataServ.remolque == undefined ){
      this.remolque_form = null;
      console.log(this.remolque_form);
    }else if( form.remolque !== "" ){
      this.remolque_form = form.remolque;
      console.log(this.remolque_form);
    }

    if(form.remolque_ref == "" && this.dataServ.remolque_ref == undefined ){
      this.remolque_ref_form = null;
      console.log(this.remolque_ref_form);
    }else if( form.remolque_ref !== "" ){
      this.remolque_ref_form = form.remolque_ref;
      console.log(this.remolque_ref_form);
    }

    if(form.accesorios == "" && this.dataServ.accesorios == undefined ){
      this.accesorios_form = null;
      console.log(this.accesorios_form);
    }else if( form.accesorios !== "" ){
      this.accesorios_form = form.accesorios;
      console.log(this.accesorios_form);
    }

    if( form.t_carga == "" && form.t_carga_esp == "" || form.t_carga == undefined ){
      if(this.dataServ.t_unidad == undefined){
        this.select_t_carga = null;
      }else{
        this.select_t_carga = this.dataServ.t_unidad;
      }
      console.log("1",this.select_t_carga);
    }else if( form.t_carga !== "" && form.t_carga_esp == "" ){
      this.select_t_carga = form.t_carga;
      console.log("2",this.select_t_carga);
    }else if(form.t_carga == "1"){
      this.select_t_carga = form.t_carga_esp;
      console.log("3",this.select_t_carga);
    }else if( form.t_carga !== "1" && form.t_carga_esp !== "" ){
      this.select_t_carga = form.t_carga;
      console.log("4",this.select_t_carga);
    }

    let datos = { "nom_empresa": form.nom_empresa, "nom_resp": form.nom_resp,
                  "ref":form.ref, "num_tel": form.num_tel, "caract": form.carac, "t_unidad":this.select_t_unidad,
                  "precio":form.precio,"v_especializado":this.v_especializado_form, "remolque":this.remolque_form,
                  "remolque_ref":this.remolque_ref_form, "accesorios": this.accesorios_form, "t_carga": this.select_t_carga};

    this._ss.act_datos_serv(datos,this.id).subscribe(data=>{
      if(data){
        $("#editarService").modal("toggle");
        this.datos();
        $.notify({
          title:"<b>Datos de servicio:</b><br>",
          message:"Los datos del servicio se editaron correctamente"
        });

      }
    });

  }

  guardar_edit_dir(){
    if(this.validForm == 1){
      let datos = { "inic_dir": this.direccion, "inic_lat": this.lat, "inic_lng":this.lng };
      this._ss.act_datos_serv(datos, this.id).subscribe(data=>{
        if(data){
          $("#tabla").removeClass("col-md-6 col-lg-6").addClass("col-md-10 col-md-offset-1");
          $("#mapa").removeClass("col-md-6 col-lg-6").addClass("hidden");
          $("#editar-dir-fin-table").attr("disabled", false);
          $("#edit-sev").attr("disabled", false);
          this.marca_ini = false;
          this.clase = 0;
          this.validForm = 0;
          this.direccion=null;
          $.notify({
            title:"<b>Dirección inicial:</b><br>",
            message:"La dirección inicial fue actualizada correctamente"
          });
          this.datos();
        }
      });
    }else if( this.validForm == 2 ){
      let datos = { "inic_dir": this.direccion, "inic_lat": this.lat, "inic_lng":this.lng };
      this._ss.act_datos_serv( datos, this.id ).subscribe(data=>{
        if(data){
          $("#tabla").removeClass("col-md-6 col-lg-6").addClass("col-md-10 col-md-offset-1");
          $("#mapa").removeClass("col-md-6 col-lg-6").addClass("hidden");
          $("#editar-dir-inicio-table").attr("disabled", false);
          $("#edit-sev").attr("disabled", false);
          this.marca_fin = false;
          this.btnEditDirFin = 0;
          this.direccion=null;
          $.notify({
            title:"<b>Dirección final:</b><br>",
            message:"La dirección final fue actualizada correctamente"
          });
          this.datos();
        }
      });
    }else{
      $.notify({
        title:"<b>Error:</b><br>",
        message:"Error al actualizar: la variable validForm puede ser invalida"
      },{
        type:"warning"
      });
    }
  }

  buscador(){
    /* No muestra autocomplete en modal, z-index
    */
    this.mapsAPILoader.load().then(() => {
        let autocomplete = new google.maps.places.Autocomplete(this.searchElement.nativeElement, { types:["address"] });
        autocomplete.addListener("place_changed", () => {
          this.ngZone.run(() => {
            let place: google.maps.places.PlaceResult = autocomplete.getPlace();
            if(place.geometry === undefined || place.geometry === null ){
              return;
            }
            this.lat = place.geometry.location.lat();
            this.lng = place.geometry.location.lng();
            this.zoom = 16;
            this._ss.geocode(this.lat + "," +this.lng).subscribe(datacode=>{
              console.log(datacode.results[0].formatted_address);
              this.direccion = datacode.results[0].formatted_address;
            });
        });
      });
    });
  }
  private number(value: string): number {
      return +value;
  }

  editar_dir_inicio(){
    $("#tabla").removeClass("col-md-10 col-md-offset-1").addClass("col-md-6 col-lg-6");
    $("#mapa").removeClass("hidden").addClass("col-md-6 col-lg-6");
    $("#editar-dir-fin-table").attr("disabled", true);
    $("#edit-sev").attr("disabled", true);
    this.clase = 1;
    this.marca_ini = true;
    this.lat = this.inic_lat;
    this.lng = this.inic_lng;
    $("#editarService").modal('toggle');
    this.agmMap.triggerResize();
    this.validForm = 1;
  }
  editar_dir_inicio_table(){
    $("#tabla").removeClass("col-md-10 col-md-offset-1").addClass("col-md-6 col-lg-6");
    $("#mapa").removeClass("hidden").addClass("col-md-6 col-lg-6");
    $("#editar-dir-fin-table").attr("disabled", true);
    $("#edit-sev").attr("disabled", true);
    this.clase = 1;
    this.marca_ini = true;
    this.lat = this.inic_lat;
    this.lng = this.inic_lng;
    this.agmMap.triggerResize();
    this.validForm = 1;
  }
  cancelar_dir_inicio_table(){
    $("#tabla").removeClass("col-md-6 col-lg-6").addClass("col-md-10 col-md-offset-1");
    $("#mapa").removeClass("col-md-6 col-lg-6").addClass("hidden");
    $("#editar-dir-fin-table").attr("disabled", false);
    $("#edit-sev").attr("disabled", false);
    this.direccion=null;
    this.marca_ini = false;
    this.clase = 0;
    this.validForm = 0;
  }

  editar_dir_fin_table(){
    $("#tabla").removeClass("col-md-10 col-md-offset-1").addClass("col-md-6 col-lg-6");
    $("#mapa").removeClass("hidden").addClass("col-md-6 col-lg-6");
    $("#editar-dir-inicio-table").attr("disabled", true);
    $("#edit-sev").attr("disabled", true);
    this.btnEditDirFin = 1;
    this.marca_fin = true;
    this.lat = this.fin_lat;
    this.lng = this.fin_lng;
    this.agmMap.triggerResize();
    this.validForm = 2;
  }
  cancelar_dir_fin_table(){
    $("#tabla").removeClass("col-md-6 col-lg-6").addClass("col-md-10 col-md-offset-1");
    $("#mapa").removeClass("col-md-6 col-lg-6").addClass("hidden");
    $("#editar-dir-inicio-table").attr("disabled", false);
    $("#edit-sev").attr("disabled", false);
    this.direccion=null;
    this.marca_fin = false;
    this.btnEditDirFin = 0;
    this.validForm = 0;

  }
  editar_dir_fin(){
    $("#tabla").removeClass("col-md-10 col-md-offset-1").addClass("col-md-6 col-lg-6");
    $("#mapa").removeClass("hidden").addClass("col-md-6 col-lg-6");
    $("#editar-dir-inicio-table").attr("disabled", true);
    $("#edit-sev").attr("disabled", true);
    this.btnEditDirFin = 1;
    this.marca_fin = true;
    this.lat = this.fin_lat;
    this.lng = this.fin_lng;
    this.agmMap.triggerResize();
    this.validForm = 2;
    $("#editarService").modal('toggle');
  }
  cancelar_dir_inicio(){
    $("#editarService").modal('toggle');
    $("#tabla").removeClass("col-md-6 col-lg-6").addClass("col-md-10 col-md-offset-1");
    $("#mapa").removeClass("col-md-6 col-lg-6").addClass("hidden");
    $("#editar-dir-fin-table").attr("disabled", false);
    this.direccion=null;
    this.btnEditDirFin = 1;
    this.marca_ini = false;
    this.clase = 0;
    this.validForm = 0;
  }

  cambio_centro(){

  }

  dragEndMarcador( evento ){
    console.log(evento);
    this._ss.geocode(evento.coords.lat + "," +evento.coords.lng).subscribe(datacode=>{
      //this.storage.guarda_st("pll_dir",datacode.results[0].formatted_address);
      console.log(datacode.results[0].formatted_address);
      this.direccion = datacode.results[0].formatted_address;
      this.lat = evento.coords.lat;
      this.lng = evento.coords.lng;
    });
  }
  dragEndMarcadorFin(evento){
    this._ss.geocode(evento.coords.lat + "," +evento.coords.lng).subscribe(datacode=>{
      //this.storage.guarda_st("pll_dir",datacode.results[0].formatted_address);
      console.log(datacode.results[0].formatted_address);
      this.direccion = datacode.results[0].formatted_address;
      this.lat = evento.coords.lat;
      this.lng = evento.coords.lng;
    });
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/servicio/servicio.component.ts